$(() => {
    $(document).on("click", ".video-box", function () {
        const src = $(this).data("src");
        $(".pp-video__player video").attr("src", src);
    });
    $(document).on("click", ".video-popup", function () {
        const src = $(this).data("src");
        $(".pp-video__player video").attr("src", src);
    });
});
